import { Component, Input } from '@angular/core';

import { ModalController, NavParams, Platform, NavController, IonContent } from '@ionic/angular/standalone';

import { EasyDebugService } from '../../services/easy-debug.service';
import { AppInitService } from '../../services/app-init.service';
import { EvsApiHeaderService } from '../../../commons/services/EvsApiHeader.service';

import { UtilsService, ToasterService } from '@commons/services';

import { EasyDebugDecorator } from '../../decorators/easy-debug.decorator';

@EasyDebugDecorator
@Component({
  selector: 'modal-error-component',
  templateUrl: 'modal-error.component.html',
  styleUrls: ['modal-error.component.scss'],
  host: {
    class: 'legacy-styles',
    '(window:resize)': 'onResize()',
  },
  imports: [IonContent],
})
export class ModalErrorComponent {
  // Data passed in by componentProps
  @Input() type: string;

  pageTitle = 'Modal Info User';
  activeLink = 'dashboard';

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  modalType = '';
  error = null;
  closable = true;

  isCordova = false;
  isDesktop = window.innerWidth > 767 ? true : false;

  banner = null;

  onResize() {
    this.isDesktop = window.innerWidth > 767;
  }

  constructor(
    public evsApiHeaderService: EvsApiHeaderService,
    public easyDebugService: EasyDebugService,
    public utils: UtilsService,
    public toasterService: ToasterService,
    public navParams: NavParams,
    private modalController: ModalController,
    public appInitService: AppInitService,
    public platform: Platform,
    public navController: NavController
  ) {
    this.isCordova = this.platform.is('cordova');
    this.modalType = this.navParams.get('type');
    this.error = this.navParams.get('error');
    this.closable = this.navParams.get('closable');
  }

  async initPage() {}

  launchToaster(config) {
    this.toasterService.create(config);
  }

  async closeModalPack() {
    if (!!this.modalController) {
      this.modalController.dismiss();
    }
  }

  async retryInit() {
    // Dismiss with 'retry' role — UserErrorHandlerService listens for this
    // to reset state and re-run init (avoids circular dependency).
    if (this.modalController) {
      this.modalController.dismiss(null, 'retry');
    }
  }

  async goHome() {
    await this.closeModalPack();
    this.navController.navigateRoot('accueil');
  }
  async retry() {
    await this.closeModalPack();
  }
}
